var React = require( 'react' );
var createReactClass = require('create-react-class');

var AppPromo = createReactClass({

    handleClickTracking: function(e) {
        var label = this.props.pageTitle;
        var action = 'Click';
        this.props.recordDownloadClick(action, label);
    },

    render: function(){
        return (
            <a href="http://get.mygihealth.io/downloadtheapp" onClick={this.handleClickTracking} id="app-promo">
                <div>
                    <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/download-app.png" alt="" />
                </div>
                <div>
                    <h3>Check out our free MyGiHealth app</h3>
                    <p>Track, understand & improve your Gi symptoms.</p>
                    <p><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" /></p>
                </div>
            </a>
        )
    }
});

module.exports = AppPromo;



// WEBPACK FOOTER //
// ./src/common/routes/components/appPromo.jsx